export default {
  action: '操作',
  actionBlockedDueToDuplicateUuid: '因裝置 UUID 重複，操作已被阻擋',
  active: '啟用',
  add: '新增',
  addAnotherIp: '新增另一個 IP',
  addDeviceHeaderwoSuite: '新增裝置: {{screen}}',
  addDevices: '新增裝置',
  addIp: '新增 IP',
  addIPAddress: '新增 IP 地址',
  addIpHeader: '新增 IP 地址: {{screen}}',
  addRole: '新增角色',
  addSuite: '新增套裝設備',
  addSuiteHeader: '新增套裝設備: {{screen}} - 套裝 {{suite}}',
  adminRoleWillHaveFullAccess: '管理員角色將擁有完全存取權限',
  all: '全部',
  and: '及',
  applianceStatus: '設備狀態',
  apply: '套用',
  assignedToDevice: '已指派至裝置',
  availableDevices: '可用裝置',
  bookingDate: '預訂日期',
  bookingRef: '預訂參考編號',
  bulkEditScreenIPs: '批次編輯影廳 IP',
  bulkHeadingMsg: '在此對 IP 所做的變更將反映至所有相關聯的影廳裝置。',
  cancel: '取消',
  ccEmails: '副本電子郵件',
  certificateAutoSync: '憑證自動同步',
  certificateExpired: '憑證已逾期',
  certificateForAllDevicesMustBeValid: '所有裝置的憑證必須有效',
  certificateNotAvailable: '此序號無可用裝置憑證。',
  certificateNotValid: '憑證無效',
  chain: '連鎖影城',
  chainSmall: '連鎖影城',
  changesSavedSuccessfully: '變更已成功儲存',
  clear: '清除',
  clearAll: '全部清除',
  clearAllSmall: '全部清除',
  clearSelection: '清除選擇',
  collapseAll: '全部收折',
  common: {
    confirm: '確認',
  },
  composition: '組合',
  compositionCount_one: '組合 (1)',
  compositionCount_other: '組合 ({{count}})',
  compositionDetails: '組合明細',
  compositionName: '組合名稱',
  confirmDelete: '確認刪除',
  confirmDeleteIP: '您確定要刪除 IP 地址 {{ip}} 嗎？',
  confirmDeleteIPAssigned:
    '此 IP 目前已指派，將會從位於 {{location}} 的裝置 {{deviceInfo}} 中斷連線。',
  confirmDeleteSuite:
    '您確定要刪除 {{screen_name}} - Suite {{suite_number}} 嗎？請選擇適當的選項以繼續。',
  content: '內容',
  contentDetails: '內容明細',
  copyLink: '複製連結',
  countTheatres_one: '1 家影院',
  countTheatres_other: '{{count}} 家影院',
  cplMarkers: 'CPL 標記',
  create: '建立',
  createdOn: '建立於',
  creditOffset: '信用抵銷',
  creditsOffset: '積分補償',
  dcpStatusTitle: 'DCP 狀態',
  deactivatedUser: '已停用使用者',
  delete: '刪除',
  deleteIp: '刪除 IP',
  deleteSuite: '刪除套裝設備',
  deleteTheatreGroup: '刪除影院群組',
  deleteTheatreGroupConfirmation:
    '您確定要刪除 {{groupName}} 嗎？此操作為永久性，無法復原。',
  deleteTheatreWarningMessage: '刪除此項將影響其存取權限，您確定要繼續嗎？',
  details: '詳細資訊',
  deviceWillBeRemoved: '裝置將從此套裝中移除',
  deviceModel: '裝置型號',
  deviceRole: '裝置角色',
  devices: '裝置',
  deviceWillBeMoved: '儲存後，裝置將移至影廳 {{destination}} 的裝置',
  deviceWillBeMovedToStandby: '裝置將移至待命狀態',
  disabled: '已停用',
  doNotIncludePrDevices: '請勿將 PR 裝置納入 KDM 產生範圍。',
  downloadAttempt: '下載嘗試',
  downloadDetails: '下載明細',
  downloadHistory: '下載歷史記錄',
  downloadKDMs: '下載 KDM',
  downloadLocation: '下載位置',
  downloadNow: '立即下載',
  downloadProgress: '已完成 {{progress}}',
  downloadSize: '下載容量',
  downloadStatus: '下載狀態',
  duplicateDeviceFound: '發現重複的裝置',
  duplicateDeviceWarning: '在 {{screens_and_suites}} 中發現重複的裝置',
  editDevice: '編輯裝置',
  editDeviceMeta: '編輯裝置中繼資料',
  editIp: '編輯 IP',
  editIpHeader: '編輯 IP - 影廳 {{screen}}',
  editRoles: '編輯角色',
  editSuite: '編輯套裝設備',
  editSuiteHeader: '編輯套裝設備: 影廳 {{screen}} - 套裝 {{suite}}',
  editTheatreGroup: '編輯影院群組',
  effectiveFrom: '生效日期',
  email: '電子郵件',
  emailKDMS: '傳送電子郵件 KDM',
  emptyScreen: '影廳尚未新增套裝設備',
  emptyStandby: '無待命裝置',
  enabled: '已啟用',
  enterEmail: '輸入電子郵件',
  enterGateway: '輸入預設閘道',
  enterIpAddress: '輸入 IP 地址',
  enterSoftwareVersion: '輸入軟體版本',
  enterSubnetMask: '輸入子網路遮罩',
  errorDownloadingKDMs: '下載 KDM 時發生錯誤',
  errorFetching: '取得資料時發生錯誤',
  errorFetchingDevices: '取得裝置時發生錯誤',
  errorFetchingFilterSettings: '取得篩選設定時發生錯誤',
  errorFetchingGroups: '載入群組清單時發生錯誤',
  errorFetchingUser: '載入使用者資訊時發生錯誤',
  errorFetchingUsersList: '載入使用者清單時發生錯誤',
  errorFetchingWireTapCount: '載入 WireTAP 總數時發生錯誤',
  errorLoadingWireTap: '載入 WireTAP 時發生錯誤',
  errorMessage: '處理您的請求時發生錯誤',
  errorReportDownload: '下載 {{report}} 報表時發生錯誤：{{error}}',
  errors: {
    fetchDeviceModels: '取得裝置型號時發生錯誤',
    fetchDeviceRoles: '取得裝置角色時發生錯誤',
    fetchTheatreInfo: '取得影院資訊時發生錯誤',
  },
  errorUploadingCertificate: '上傳憑證時發生錯誤',
  expandAll: '全部展開',
  expired: '已逾期',
  expiredOn: '到期於',
  expiring: '即將到期（剩餘 {{days}} 天）',
  expiring_1: '即將到期',
  expiryOn: '到期日',
  failedToDeleteTheatreGroup: '無法刪除影院群組',
  failedToDeleteTheatreGroupMessage: '刪除影院群組時發生錯誤',
  failedToRemoveUser: '無法移除使用者',
  failedToSendUserInvite: '無法發送使用者邀請',
  failedToUpdateUser: '無法更新使用者',
  fetchCompositions: '載入組合時發生錯誤',
  fetchingRoles: '正在取得角色...',
  fetchTheatres: '載入影院時發生錯誤',
  filter: '篩選',
  filterBy: '依…篩選',
  filterByTheatres: '依影院篩選',
  filterPanelCompositionType: '組合類型',
  filterPanelCompositionTypeOptions_advertisement: '廣告',
  filterPanelCompositionTypeOptions_feature: '正片/長片',
  filterPanelCompositionTypeOptions_others: '其他',
  filterPanelCompositionTypeOptions_psaPolicy: '公益廣告/政策宣導',
  filterPanelCompositionTypeOptions_trailerTeaserPromo: '預告片/前導片/宣傳片',
  filterPanelDcpDownloadStatus: 'DCP 下載狀態',
  filterPanelDcpIngestStatus: 'DCP 攝取狀態',
  filterPanelKdmIngestStatus: 'KDM 攝取狀態',
  filterPanelKdmStatus: 'KDM 交付狀態',
  filterPanelKdmValidity: 'KDM 有效性',
  filterPanelTheatresPlaceHolder: '搜尋影院',
  filterPanelTheatresTitle: '影院',
  filters: '篩選條件',
  from_time_of_booking: '自預訂時起。',
  fullAccess: '完全存取權限',
  future: '未來有效',
  gateway: '預設閘道',
  generateReport: '產生報表',
  groupCount_one: '{{count}} 個群組',
  groupCount_other: '{{count}} 個群組',
  groupName: '群組名稱',
  groupsCreateGroupCancel: '取消',
  groupsCreateGroupCreateTheatreGroups: '建立影院群組',
  groupsCreateGroupGroupCreated: '群組已建立',
  groupsCreateGroupGroupName: '群組名稱',
  groupsCreateGroupGroupPlaceHolderName: '輸入群組名稱',
  groupsCreateGroupHeaderTitle: '建立群組',
  groupsCreateGroupSaveChanges: '儲存變更',
  groupsCreateGroupTheatreSelection: '選擇影院',
  groupsHeaderCreateTheatreGroupButton: '建立影院群組',
  groupsHeaderViewLogsButton: '檢視日誌',
  groupUpdated: '群組已更新',
  holdoverKdmRequests: '延長放映 KDM 請求',
  hour: '小時',
  iabScreens: 'IAB 影廳',
  inbox: '收件匣',
  invalidEmail: '無效的電子郵件地址',
  ipRequired: '必須輸入 IP 地址',
  ipAddress: 'IP 地址',
  ipAddress_1: 'IP 地址',
  ipAlreadySelectedInForm: '此 IP 已被選擇/指派。請選擇另一個 IP。',
  ipCount_one: 'IP (1)',
  ipCount_other: 'IP ({{count}})',
  kdmDetails: 'KDM 明細',
  kdmValidityTheatreTimeZone: 'KDM 有效性（影院時區）',
  lastUpdatedBy: '上次更新者',
  lastUpdatedOn: '上次更新時間',
  linkExpiredOnDownload: '無法開始下載。交付連結已逾期或不再符合下載資格。',
  linkReceivedOn: '連結接收於',
  loading: '正在載入',
  location: '位置',
  logsTheatreGroups: '日誌：影院群組',
  minute: '分鐘',
  moveModalText: '裝置 {{name}} 將移至待命狀態，是否繼續？',
  moveTo: '移至',
  moveToScreen: '影廳 {{number}}',
  moveToStandby: '移至待命狀態',
  moveToStandbyDevices: '移至待命裝置',
  moveToUnmapped: '移至影廳 {{number}} 裝置',
  movie: '電影',
  movieName: '電影名稱',
  multiThumbprintKdm: '配置 DC2 (DCP 2000) 伺服器的多指紋 KDM 影廳',
  multiThumbprintKdmOtherServices: '配置其他伺服器的多指紋 KDM 影廳',
  name: '名稱',
  needs_1_SM_RMB_msg:
    '每個套裝設備必須正好包含 1 個 SM/1 個 RMB。請新增帶有憑證的 SM/RMB 裝置以繼續',
  newData: '新資料',
  newRequestCreated: '已建立新請求，請求 ID 為 {{requestId}}。',
  no_compositions: '無組合',
  no_theatres: '無可用影院',
  noAccess: '無存取權限',
  noBookings: '無可用預訂',
  noData: '無資料',
  noExpiredBookings: '未找到逾期的 WireLink 下載項目。',
  noIpFound: '無可用 IP',
  noMatchFound: '未找到相符項',
  noResultsFound: '未找到結果',
  normalKdm: '一般 KDM',
  notDownloaded: '未下載',
  notSelected: '未選擇',
  noWiretapAvailable: '無可用 WireTAP',
  oldData: '舊資料',
  optional: '選填',
  osVersion: '作業系統版本',
  pending: '待處理',
  readyToDownload: '準備下載',
  receivedOn: '接收於',
  recipientDetails: '收件人明細',
  recipientEmails: '收件人電子郵件',
  remove: '移除',
  removeFromTheatre: '從影院中移除',
  removeModalText: '您確定要從影院中移除 {{name}} 嗎？',
  removeUser: '移除使用者',
  removeUserConfirmation:
    '移除此使用者將終止其在此公司的存取權限。該使用者將無法登入或執行任何操作。',
  reportInitiated: '{{report}} 已啟動。',
  reportReady: '{{report}} 已準備就緒。',
  reportsheaderTitle: '報表',
  requestedBy: '請求者',
  requestedKdmValidity: '請求的 KDM 有效性',
  requestedOn: '請求時間',
  requestFailed: '請求失敗',
  requestFailedMessage: '無法傳送請求。請重試。',
  requestSent: '請求已傳送',
  role: '角色',
  roles: '角色',
  save: '儲存',
  saveChanges: '儲存變更',
  screen: '影廳',
  screenInactive: '停用',
  screens: '影廳',
  searchByLocation: '依位置搜尋',
  searchByNameOrEmail: '依姓名或電子郵件搜尋',
  searchBySerialNo: '依序號搜尋',
  searchByTheatreGroup: '依影院群組搜尋',
  searchByTheatreGroupName: '依影院群組名稱搜尋',
  searchByTheatreName: '依影院名稱搜尋',
  searchCompositions: '依組合名稱搜尋',
  searchCompositionsPlaceholder: '搜尋組合',
  searchDeviceModel: '搜尋裝置型號',
  searchForChain: '搜尋連鎖影城',
  searchForLocation: '搜尋位置',
  searchForOsVersion: '搜尋作業系統版本',
  searchForPublicIp: '搜尋公用 IP',
  searchForSerialNumber: '搜尋序號',
  searchForTheatre: '搜尋影院',
  searchForWiretap: '搜尋 WireTAP',
  searchMovies: '依電影名稱搜尋',
  searchPlaceholder: '搜尋您管理的影院',
  searchSerialNumber: '搜尋序號',
  searchTheatres: '依影院名稱搜尋',
  selectIpAddress: '選擇 IP 地址',
  selectRole: '選擇角色',
  sendInvite: '傳送邀請',
  serialNumber: '序號',
  serialNumber_1: '序號',
  show: '顯示',
  showingCountResults_one: '顯示 1 個結果：',
  showingCountResults_other: '顯示 {{count}} 個結果：',
  showingResults: '顯示第 {{start}}-{{end}} 項，共 {{total}} 項',
  showingResultsFor: '顯示結果：',
  showMore: '顯示更多',
  softwareVersion: '軟體版本',
  somethingWentWrong: '發生錯誤',
  standby: '待命',
  standbyDevices: '待命裝置',
  standbyHeader_one: '待命裝置 (1)',
  standbyHeader_other: '待命裝置 ({{count}})',
  status: '狀態',
  subnetMask: '子網路遮罩',
  suite: '套裝設備',
  suiteCreationRules: '套裝設備建立規則',
  suiteDevicesExpiredMsg: '套裝包含憑證已逾期的裝置',
  suiteEffectiveFrom: '套裝設備生效日期',
  suiteInvalid: '套裝設備無效，無法產生 KDM',
  suiteLogs: '套裝設備日誌',
  suiteMustContain:
    '套裝設備必須包含正好 {{smCount}} 個 SM 或 {{rmbCount}} 個 RMB 裝置。',
  suiteMustContainAdLd: '套裝設備必須至少包含 1 個角色為 LD 的附加裝置',
  suiteMustContainLDorPR:
    '套裝設備必須至少包含 1 個角色為 LD 或 PR 的附加裝置。',
  suiteMustContainSm: '套裝設備必須包含正好 {{smCount}} 個 SM 裝置。',
  suiteMustContainSMOBE: '套裝設備必須包含正好 1 個 SM / 帶有 SM 裝置的 OBAE。',
  suiteNo: '套裝 {{number}}',
  theatre: '影院',
  theatre_1: '影院',
  theatre_header: '影院',
  theatreCount: '影院數量',
  theatreGroup: '影院群組',
  theatreGroupDeleted: '影院群組已刪除',
  theatreGroupDeletedMessage: '已刪除 {{groupName}}',
  theatreGroupDetails: '影院群組明細',
  theatreGroups: '影院群組',
  theatreName: '影院名稱',
  theatres: '影院',
  theatresList: '影院列表',
  theatreSmall: '影院',
  theatreTimeZone: '影院時區',
  trackingInfo: '追蹤資訊',
  unarchival_may_take: '解封存可能需要',
  undo: '復原',
  unmappedDevices_one: '裝置 (1)',
  unmappedDevices_other: '裝置 ({{count}})',
  untitled: '未命名',
  update: '更新',
  updatedBy: '更新者',
  updatedOn: '更新於',
  uploadCertificate: '上傳憑證',
  uploadDeviceCertificate: '上傳裝置憑證',
  user: '使用者',
  userCount_one: '{{1}} 位使用者',
  userCount_other: '{{count}} 位使用者',
  userInviteSent: '使用者邀請已成功發送',
  userLogs: '使用者日誌',
  userRemoved: '使用者已移除',
  users: '使用者',
  usersHeaderButtonsInviteUser: '邀請使用者',
  usersHeaderButtonsViewLogs: '檢視日誌',
  usersHeaderTitle: '管理使用者',
  validFrom: '有效期限自',
  validNow: '目前有效',
  validTo: '有效至',
  verificationStatus: '驗證狀態',
  viewAll: '檢視全部',
  viewAllTheatreGroups: '檢視所有影院群組',
  viewCreditOffset: '鳴謝：{{value}}',
  viewSuiteLogs: '檢視套裝設備日誌',
  viewTheatreGroup: '檢視影院群組',
  warning: '警告',
  wireLinkCopiedToClipboard: 'WireLink 已複製到剪貼簿',
  wireLinkCopyFailed: '複製失敗，請重試',
  wireLinkDetails: 'WireLink 明細',
  wireLinks: 'WireLink 連結',
  wiretaps: 'WireTAP',
  wiretapStatusReport: 'WireTAP 狀態報表',
  removeDevice: '移除裝置',
  deleteIpTitle: '刪除 IP 地址 - {{ip}}',
  appliances: '裝置',
  noResultsFor: '沒有結果：',
  city: '城市',
  province: '省份',
  country: '國家',
  confirmAction: '確認操作',
  RequestId: '請求 ID：{{requestId}}',
  moveToUnmapped_name: '移動到 {{name}} 裝置',
  language: '語言',
  subtitleLanguage: '字幕語言',
  mainCaption: '主字幕',
  ratings: '評分',
  type: '類型',
  dciStandard: 'DCI 標準',
  closedSubtitles: '隱藏字幕',
  frameRate: '幀率',
  audioFormats: '音訊格式',
  resolution: '解析度',
  closedCaptions: '隱藏字幕',
  stereoType: '立體聲類型',
  aspectRatio: '長寬比',
};
